<div class="page-layout carded fullwidth left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="margin:0px">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-16" (click)="location.back()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h2 class="m-0">{{'ODS.TITULO' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
          <!-- CONTENT TOOLBAR -->
          <div class="toolbar px-24 py-8" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row">
              <span *ngIf="!modoEdicion">{{'ODS.TOOLBAR.NUEVA' | translate}}</span>
              <span *ngIf="modoEdicion">{{'ODS.TOOLBAR.EDITAR' | translate}}</span>
              <b class="ml-5">{{'ODS.TOOLBAR.CAMBIOS' | translate}}</b>
            </div>
            <button *ngIf="modoEdicion && descargaInfoOk" mat-button mat-raised-button color="primary" (click)="generatePDF()">{{'ODS.TOOLBAR.DESCARGAR' | translate}}</button>
          </div>
          <!-- / CONTENT TOOLBAR -->
          <div class="w100 p-20" fxFlex>
            <ng-container *ngIf="inputsListos">
              <mat-horizontal-stepper [linear]="true" #stepper>

                <mat-step *ngFor="let formulario of datasets; let idxForm = index; first as first; last as last;" [stepControl]="formulario">
                  <ng-template matStepLabel>{{'ODS.FORMULARIOS.' + idxForm | translate}}</ng-template>
                  <form [formGroup]="formulario">
                    <div class="" fxLayout="column" fxLayoutAlign="start stretch">
                      <div class="" fxLayout="row" fxLayoutAlign="space-between stretch" *ngFor="let fila of arreglosInputs[idxForm].filas">
                        <ng-container *ngFor="let campo of fila" >
                          <mat-form-field appearance="outline" [fxFlex]="campo.ancho" *ngIf="campo.validaciones.visible">
                            <mat-label>{{'ODS.CAMPOS.' + campo.clave | translate}}</mat-label>
                            <ng-container [ngSwitch]="campo.validaciones.tipo">
                              <mat-select *ngSwitchCase="'lista'" [formControlName]="campo.clave" [required]="campo.validaciones.obligatorio" (selectionChange)="campo.validaciones.funcion != undefined ? [this[campo.validaciones.funcion]($event.value), actualizaDatos(campo.clave, formulario)] : actualizaDatos(campo.clave, formulario)">
                                <ng-container *ngIf="datosCatalogos[campo.clave]">
                                  <mat-option *ngFor="let opcion of datosCatalogos[campo.clave]" [value]="opcion[campo.validaciones.datoLista]">
                                    <!-- <ng-container *ngIf="campo.validaciones.tagLista == undefined; else listaTag">
                                      {{opcion[campo.validaciones.datoLista]}}
                                    </ng-container> -->
                                    <ng-container>
                                      {{campo.validaciones.tagLista != undefined ? opcion[campo.validaciones.tagLista] : 'ODS.CATALOGOS.' + campo.clave + '.' + opcion[campo.validaciones.datoLista] | translate}}
                                    </ng-container>
                                    <!-- <ng-template #listaTag>
                                      {{opcion[campo.validaciones.tagLista]}}
                                    </ng-template> -->
                                  </mat-option>
                                </ng-container>
                              </mat-select>
                              <input *ngSwitchDefault matInput type="text" [formControlName]="campo.clave" [required]="campo.validaciones.obligatorio" (blur)="campo.validaciones.funcion != undefined ? [this[campo.validaciones.funcion]($event.value), actualizaDatos(campo.clave, formulario)] : actualizaDatos(campo.clave, formulario)">
                            </ng-container>

                            <mat-icon matSuffix class="secondary-text">{{campo.icono}}</mat-icon>
                            <mat-hint align="end" *ngIf="campo.validaciones.hintMax">{{formulario.controls[campo.clave].value.length}} / {{campo.validaciones.maximos}}</mat-hint>
                            <mat-error *ngIf="formulario.controls[campo.clave].errors != null" class="divError">
                              <div fxLayout="column">
                                <ng-container *ngFor="let err of getErrorList(formulario.controls[campo.clave].errors)">
                                  <ng-container *ngIf="campo.validaciones.textEspecial" [ngSwitch]="campo.clave">
                                    <ng-container *ngSwitchCase="'anioFundacion'" [ngSwitch]="err">
                                      <span class="pb-5" *ngSwitchCase="'max'">{{'ODS.ERRORES.TEXT_ESPEC_ANIOFUNDA' | translate}}</span>
                                      <span class="pb-5" *ngSwitchCase="'min'">{{'ODS.ERRORES.' + err | translate}}</span>
                                      <span class="pb-5" *ngSwitchCase="'pattern'">{{'ODS.ERRORES.' + err | translate}}</span>
                                    </ng-container>
                                  </ng-container>
                                  <ng-container *ngIf="!campo.validaciones.textEspecial">
                                  <span class="pb-5" >{{'ODS.ERRORES.' + err | translate}}</span>
                                  </ng-container>
                                </ng-container>
                              </div>
                            </mat-error>
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </div>
                  </form>
                  <div fxLayout="row" fxLayoutAlign="end center">
                    <button mat-raised-button matStepperPrevious color="accent" class="mr-20" *ngIf="!first">{{'ODS.BOTONES.BACK' | translate}}</button>
                    <button mat-raised-button matStepperNext color="primary" *ngIf="!last">{{'ODS.BOTONES.NEXT' | translate}}</button>
                  </div>
                </mat-step>

              </mat-horizontal-stepper>
            </ng-container>
          </div>
        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>

<div class="guardandoTemplate" *ngIf="actualiando" fxLayout="row" fxLayoutAlign="start center">
  <em class="mr-20">{{'ODS.MODALES.GUARDANDO' | translate}}</em>
  <mat-spinner diameter="25"></mat-spinner>
</div>
